<div class="h-100 d-flex justify-content-around align-items-center gap-0_5">
  <button class="btn delete-report-btn" [disabled]="isDeleteReportDisabled()" (click)="onClick('delete')" [tooltip]="tooltipText()">
    <i class="fa-trash-alt far"></i>
  </button>
</div>
